// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f61b7bc","455":"1be34e9d"}[chunkId] + ".chunk.js";
};